import { render, staticRenderFns } from "./ProductSaleNumberPieChart.vue?vue&type=template&id=0ed54e12&scoped=true&"
import script from "./ProductSaleNumberPieChart.vue?vue&type=script&lang=js&"
export * from "./ProductSaleNumberPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed54e12",
  null
  
)

export default component.exports